import { useState } from "react";
import type { AuditLogFilters } from "@/lib/audit-log.api";
import type { AuditLogPageFilters } from "../auditLogPage.types";

const INITIAL_FILTERS: AuditLogPageFilters = {
  userId: undefined,
  action: undefined,
  entityType: undefined,
  from: "",
  to: "",
};

export function useAuditLogPageState() {
  const [filters, setFilters] = useState<AuditLogPageFilters>(INITIAL_FILTERS);
  const [page, setPage] = useState(1);

  function updateFilters(nextFilters: Partial<AuditLogPageFilters>) {
    setFilters((current) => ({ ...current, ...nextFilters }));
    setPage(1);
  }

  function resetFilters() {
    setFilters(INITIAL_FILTERS);
    setPage(1);
  }

  const apiFilters: AuditLogFilters = {
    userId: filters.userId,
    action: filters.action,
    entityType: filters.entityType,
    from: filters.from || undefined,
    to: filters.to || undefined,
  };

  return {
    filters,
    apiFilters,
    page,
    setPage,
    updateFilters,
    resetFilters,
  };
}
